import { render, staticRenderFns } from "./ui_demos.vue?vue&type=template&id=65a88c7c&scoped=true&"
import script from "./ui_demos.vue?vue&type=script&lang=ts&"
export * from "./ui_demos.vue?vue&type=script&lang=ts&"
import style0 from "./ui_demos.vue?vue&type=style&index=0&id=65a88c7c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a88c7c",
  null
  
)

export default component.exports